import { render, staticRenderFns } from "./ProvedoresDisponibilidadePage.vue?vue&type=template&id=e5b68ba6&scoped=true"
import script from "./ProvedoresDisponibilidadePage.vue?vue&type=script&lang=js"
export * from "./ProvedoresDisponibilidadePage.vue?vue&type=script&lang=js"
import style0 from "./ProvedoresDisponibilidadePage.vue?vue&type=style&index=0&id=e5b68ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b68ba6",
  null
  
)

export default component.exports